__webpack_require__.j = "resources";